import React from 'react';
import styles from './ErrorPage.module.css';

interface ErrorPageProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryText?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ 
  title = 'Error Loading Page',
  message,
  onRetry,
  retryText = 'Try Again'
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.errorContainer}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" className={styles.errorIcon}>
          <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" />
          <path d="M12 8v4M12 16h.01" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <h3 className={styles.errorTitle}>{title}</h3>
        <p className={styles.errorMessage}>{message}</p>
        {onRetry && (
          <button className={styles.retryButton} onClick={onRetry}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path 
                d="M1 4v6h6M23 20v-6h-6" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round"
              />
              <path 
                d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round"
              />
            </svg>
            {retryText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;